import { render } from "./HeroBackgroundBuilding.vue?vue&type=template&id=d397b4cc&ts=true"
import script from "./HeroBackgroundBuilding.vue?vue&type=script&lang=ts"
export * from "./HeroBackgroundBuilding.vue?vue&type=script&lang=ts"

import "./HeroBackgroundBuilding.vue?vue&type=style&index=0&id=d397b4cc&lang=scss"

import exportComponent from "C:\\Arbeit\\wordpress_projekte\\castroper-klimahelden\\wp-content\\themes\\cas-klimahelden-theme\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__